"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SubscriptionTable/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_table_module = require("./table.json"),
    table_module = module_table_module.default || module_table_module,
    Types = module_table_module.Types,
    Common = module_table_module.Common,
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    Table_template = require("./components/Table/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Table_tag = marko_loadTag(Table_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template);

function render(input, out, __component, component, state) {
  var data = input;

  Row_tag(marko_mergeNestedTagsHelper({
      renderBody: function(out, $nestedTagRow$0) {
        var $for$0 = 0;

        marko_forIn(Types, function(type, { table, price, per }) {
          var $keyScope$0 = "[" + (($for$0++) + "]");

          Row_col_nested_tag({
              ns: "col",
              qs: "col-4",
              hs: "col-6",
              fs: "col",
              renderBody: function(out) {
                Table_tag({
                    type: type,
                    table: table,
                    price: price,
                    per: per,
                    common: Common
                  }, out, __component, "2" + $keyScope$0, [
                  [
                    "subscribe",
                    () => component.emit( 'subscribe', { type, ...Types[ type ] } ),
                    false
                  ]
                ]);
              }
            }, $nestedTagRow$0);
        });
      }
    }), out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
